let CancelToken;
let source;

export default {
  state: {
    imageForCrop: '',
    processingSearchProduct: false,
    productAttributes: [],
    productCategory: '',
    productShot: [],
    productShotKeyActive: -1,
    searchProduct: [],
    selectedProduct: '',
    showModal: false,
    showModalCropPhoto: false,
    showModalEditPhoto: false,
    showModalUploadPhoto: false,
    suggestedProduct: '',
    temporaryProductShot: '',
    editPhoto: {
      file: '',
      caption: '',
    },
    addReviewSource: '',
  },
  mutations: {
    setEditPhotoPropertyOf(state, { name, value }) {
      state.editPhoto[name] = value;
    },
    addDataProductShot(state, { fileImageBase64, caption }) {
      if (state.productShot.length) {
        state.productShot.push({ file: fileImageBase64, caption: caption });
      } else {
        const arr = [{ file: fileImageBase64, caption: caption }];
        state.productShot = arr;
      }
    },
    removeTemporaryProductShot(state, key) {
      if (state.temporaryProductShot[key]) {
        state.temporaryProductShot.splice(key, 1);
      }
    },
    removeAllTemporaryProductShot(state) {
      if (state.temporaryProductShot.length) {
        state.temporaryProductShot = [];
      }
    },
    addDataTemporaryProductShot(state, fileImageBase64) {
      if (state.temporaryProductShot.length) {
        state.temporaryProductShot.push({ file: fileImageBase64, caption: '' });
      } else {
        const arr = [{ file: fileImageBase64, caption: '' }];
        state.temporaryProductShot = arr;
      }
    },
    mappingProductAttributes(state, { dataCombinations, component }) {
      const dataAttributes = (dataCombinations || []).map((c) => c.attribute);

      // {shade: [], size: []} ; use keys to manage duplicate attr groups
      const productAttributesSet = {};
      dataAttributes.forEach((elem) => {
        this._vm.$SO.each(elem, (prop, arrAttribute) => {
          if (prop.toLowerCase() !== 'non specify') {
            if (typeof productAttributesSet[prop] == 'undefined' || !productAttributesSet[prop].length) {
              productAttributesSet[prop] = [];
            }
            // prevent duplicate "blue" from several combinations
            if (productAttributesSet[prop].filter((a) => a.name === arrAttribute.name).length === 0) {
              productAttributesSet[prop].push(arrAttribute);
            }
          }
        });
      });

      // convert {shade: [], size: []}
      // to [{name: 'shade', data: []}, {name: 'size', data:[]}]
      this._vm.$SO.each(productAttributesSet, (key, val) => {
        state.productAttributes.push({ name: key, data: val });
      });

      const createTempForAttributes = {};
      this._vm.$SO.each(state.productAttributes, (key, objAttribute) => {
        createTempForAttributes[objAttribute.name] = null;
      });

      if (component.temp) {
        component.temp.attributes = createTempForAttributes;
      }
    },
    removeProductShot(state, productShotKey) {
      const filterProductShot = [];

      state.productShot[productShotKey].caption = null;
      state.productShot[productShotKey].file = null;

      state.productShot.filter((obj) => {
        if (obj.file) {
          filterProductShot.push(obj);
        }
      });
      // reassign with new val
      state.productShot = filterProductShot;
    },
    resetDataSearchProduct(state) {
      state.searchProduct = [];
    },
    resetDataRelatedWriteReview(state) {
      state.productAttributes = [];
      state.productCategory = '';
      state.productShot = [];
      state.temporaryProductShot = '';
    },
    resetDataTemporaryProductShot(state) {
      state.temporaryProductShot = '';
    },
    mergeDataSearchProduct(state, dataSearchProduct) {
      state.searchProduct = state.searchProduct.concat(dataSearchProduct);
    },
    setDataSearchProduct(state, dataSearchProduct) {
      state.searchProduct = dataSearchProduct;
    },
    setDataSuggestedProduct(state, dataSuggestedProduct) {
      state.suggestedProduct = dataSuggestedProduct;
    },
    setAddReviewSource(state, data) {
      state.addReviewSource = data;
    },
    setImageForCrop(state, dataImage) {
      state.imageForCrop = dataImage;
    },
    setSelectedProduct(state, dataSelectedProduct) {
      state.selectedProduct = dataSelectedProduct;
    },
    setShowModal(state, newVal) {
      state.showModal = newVal;
      if (newVal) {
        this._vm.$SO('#app').addClass('no-scroll');
      } else {
        this._vm.$SO('#app').removeClass('no-scroll');
      }
    },
    setModalCropPhoto(state, newVal) {
      state.showModalCropPhoto = newVal;
    },
    addKeyToSelectedProduct(state, { key, value }) {
      state.selectedProduct[key] = value;
    },
    setModalEditPhoto(state, { newValModal, productShotKey }) {
      const newKeyProductShot = newValModal ? productShotKey : -1;
      state.showModalEditPhoto = newValModal;
      state.productShotKeyActive = newKeyProductShot;
      if (newValModal) {
        this._vm.$SO('#app').addClass('no-scroll');
      } else {
        this._vm.$SO('#app').removeClass('no-scroll');
      }
    },
    setModalUploadPhoto(state, newVal) {
      state.showModalUploadPhoto = newVal;
      if (newVal) {
        this._vm.$SO('#app').addClass('no-scroll');
      } else {
        this._vm.$SO('#app').removeClass('no-scroll');
      }
    },
    setProcessingSearchProduct(state, newVal) {
      state.processingSearchProduct = newVal;
    },
    setProductCategory(state, dataProductCategory) {
      state.productCategory = dataProductCategory;
    },
    updateProductShotImage(state, { productShotKey, file }) {
      state.productShot[productShotKey].file = file;
    },
    updateTemporaryProductShotImage(state, { productShotKey, file }) {
      state.temporaryProductShot[productShotKey].file = file;
    },
    updateProductShotCaption(state, { productShotKey, newCaption }) {
      state.productShot[productShotKey].caption = newCaption;
    },
    updateTemporaryProductShotCaption(state, { productShotKey, newCaption }) {
      state.temporaryProductShot[productShotKey].caption = newCaption;
    },
  },
  actions: {
    removeTemporaryProductShot({ commit }, payload) {
      commit('removeTemporaryProductShot', payload);
    },
    removeAllTemporaryProductShot({ commit }, payload) {
      commit('removeAllTemporaryProductShot', payload);
    },
    addDataProductShot({ commit }, payload) {
      commit('addDataProductShot', payload);
    },
    addDataTemporaryProductShot({ commit }, fileImageBase64) {
      commit('addDataTemporaryProductShot', fileImageBase64);
    },
    getRecentlyBought({ commit }, payload) {
      let params = {};
      if (Object.keys(payload).length) {
        params = payload;
      }
      return this._vm.$MS_ORDER_API_URL.get('users/me/recently-bought', params);
    },
    getSuggestedProduct({ commit }) {
      return new Promise((resolve, reject) => {
        this._vm
          .$MS_SOCO_PUBLIC_API_URL('products?limit=12')
          .then((response) => {
            if (response.status === 200) {
              commit('setDataSuggestedProduct', response.data.data);
              resolve(response);
            } else {
              commit('setDataSuggestedProduct', []);
              reject(response);
            }
          })
          .catch((err) => {
            console.log(err);
            commit('setDataSuggestedProduct', []);
            reject(err);
          });
      });
    },
    resetDataSearchProduct({ commit }) {
      commit('resetDataSearchProduct');
    },
    searchProduct({ commit, state, dispatch }, newQuery) {
      if (newQuery.length < 3) {
        if (typeof source !== 'undefined') {
          source.cancel(false);
        }
        commit('setProcessingSearchProduct', false);
        return false;
      }

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }

      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      commit('setProcessingSearchProduct', true);
      this._vm
        .$MS_CATALOG_API_URL('v3/search', {
          params: {
            filter: {
              $and: [
                {
                  $or: [{ deleted_at: null }, { deleted_at: { $exists: false } }],
                },
              ],
              keyword: newQuery,
              is_active_in_review: true,
              is_purchased_product: true,
              name: { $ne: null },
              brand: { $ne: null },
            },
            limit: 10,
          },
          cancelToken: source.token,
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setDataSearchProduct', response.data.data);
          }
          commit('setProcessingSearchProduct', false);
        })
        .catch((error) => {});
    },
    loadMoreSearchProduct({ commit, state }, { searchValue, skip, limit }) {
      return this._vm.$MS_CATALOG_API_URL('v3/search', {
        params: {
          filter: {
            $and: [
              {
                $or: [{ deleted_at: null }, { deleted_at: { $exists: false } }],
              },
            ],
            keyword: searchValue,
            is_active_in_review: true,
            is_purchased_product: true,
            name: { $ne: null },
            brand: { $ne: null },
          },
          limit: limit,
          skip: skip,
        },
      });
    },
    getProductCategory({ commit }, productId) {
      this._vm
        .$MS_SOCO_PUBLIC_API_URL('product/categories', {
          params: {
            filter: {
              _id: productId,
            },
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit('setProductCategory', response.data.data);
          }
        })
        .catch((error) => {
          commit('setProductCategory', []);
        });
    },
    removeProductShot({ commit }, productShotKey) {
      commit('removeProductShot', productShotKey);
    },
    setDataSelectedProduct({ commit, dispatch, state }, { dataSelectedProduct, component }) {
      if (state.selectedProduct) {
        commit('resetDataRelatedWriteReview');
      }

      commit('setSelectedProduct', dataSelectedProduct);
      commit('mappingProductAttributes', {
        dataCombinations: dataSelectedProduct ? dataSelectedProduct.combinations : [],
        component,
      });
      if (dataSelectedProduct.categories && dataSelectedProduct.categories[0]) {
        // dispatch('getProductCategory', dataSelectedProduct.categories[0]["id"])
        const category = dataSelectedProduct.category
          ? dataSelectedProduct.category
          : dataSelectedProduct.default_category;
        commit('setProductCategory', category);
      }
      dispatch('setModalSearchProduct', false);
    },
    setImageForCrop({ commit }, dataImage) {
      commit('setImageForCrop', dataImage);
    },
    setModalCropPhoto({ commit }, newVal) {
      commit('setModalCropPhoto', newVal);
    },
    setModalEditPhoto({ commit }, { newValModal, productShotKey }) {
      commit('setModalEditPhoto', { newValModal, productShotKey });
    },
    setModalSearchProduct({ commit }, newVal) {
      commit('setShowModal', newVal);
    },
    setModalUploadPhoto({ commit }, newVal) {
      commit('setModalUploadPhoto', newVal);
    },
    updateProductShotImage({ commit }, payload) {
      commit('updateProductShotImage', payload);
    },
    updateTemporaryProductShotImage({ commit }, payload) {
      commit('updateTemporaryProductShotImage', payload);
    },
  },
  getters: {},
};
